<!-- src/components/shared/SliderArrows.vue -->
<template>
  <div class="slider-arrows" :class="[position, { visible: show }]">
    <button
      class="arrow-btn"
      :disabled="!canScrollLeft"
      @click="$emit('scroll', 'left')"
    >
      ‹
    </button>
    <button
      class="arrow-btn"
      :disabled="!canScrollRight"
      @click="$emit('scroll', 'right')"
    >
      ›
    </button>
  </div>
</template>

<script>
export default {
  name: 'SliderArrows',

  props: {
    canScrollLeft: {
      type: Boolean,
      default: false,
    },
    canScrollRight: {
      type: Boolean,
      default: false,
    },
    /** Позиция: 'top-right', 'bottom-right', 'inline' */
    position: {
      type: String,
      default: 'inline',
    },
    /** Показывать стрелки */
    show: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['scroll'],
}
</script>

<style scoped>
.slider-arrows {
  display: flex;
  gap: 12px;
}

.slider-arrows:not(.visible) {
  visibility: hidden;
}

.slider-arrows.bottom-right {
  position: absolute;
  bottom: -60px;
  right: 0;
}

.slider-arrows.top-right {
  position: absolute;
  top: 0;
  right: 0;
}

.arrow-btn {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: none;
  background: #0095ec;
  color: white;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 149, 236, 0.4);
}

.arrow-btn:hover:not(:disabled) {
  background: #0080cc;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 149, 236, 0.5);
}

.arrow-btn:active:not(:disabled) {
  transform: translateY(0);
}

.arrow-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  box-shadow: none;
}
</style>